







































































































































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
// import { decorationData, questionData, testData, QuestionDataType } from "../../config/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { number } from "echarts";

@Component({
  name: "auditSetting_select",
  components: {},
  filters: {},
})
export default class auditSetting_select extends Vue {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  logicItem?: any;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  ifItems?: any;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  noneDecoItems?: any;
  @Prop({
    type: Number,
    default: 0,
  })
  index?: any;

  deleteLogic(index: number) {
    this.$emit("delete");
  }

  ifItemChange(value: any, index: any) {
    console.log("ifItemChange", value, index);
    if (value) {
      let oifItemIndex: any = this.noneDecoItems.findIndex((item: any) => {
        return item.data.id == value;
      });
      if (oifItemIndex >= 0) {
        this.logicItem.ifItemIndex = oifItemIndex;
        const oifItem: any = this.noneDecoItems[oifItemIndex];
        this.logicItem.itemOptions = [];
        this.logicItem.compareItem = "";
        this.logicItem.compareOptions = [];

        this.logicItem.ifItemOptions = oifItem.data.optionsList;
        this.logicItem.ifItemIsRadio = oifItem.data.type == 1 || oifItem.data.type == 9;
      }
    }
  }

  compareItemChange(value: any, index: any) {
    console.log("ifItemChange", value, index);
    if (value) {
      let itemindex: any = this.noneDecoItems.findIndex((item: any) => {
        return item.data.id == value;
      });
      if (itemindex >= 0) {
        this.logicItem.compareItemIndex = itemindex;
        const ocompareItem: any = this.noneDecoItems[itemindex];
        this.logicItem.compareOptions = [];

        this.logicItem.compareItemOptions = ocompareItem.data.optionsList;
        this.logicItem.compareItemIsRadio = ocompareItem.data.type == 1 || ocompareItem.data.type == 9;
      }
    }
  }

  validateIfItem(rule: any, value: string, callback: any) {
    let ifitemExist = this.ifItems.some((nitem: any) => {
      return nitem.data.id == value;
    });
    if (!ifitemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validateItemOptions(rule: any, value: any, callback: any) {
    let logicIndex = rule.field.split(".")[1];
    let ifItemOptions = this.logicItem.ifItemOptions;
    const itemExist = value.every((id: string) => {
      return ifItemOptions.some((op: any) => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }
  validateItemCompareOptions(rule: any, value: any, callback: any) {
    let logicIndex = rule.field.split(".")[1];
    let ifItemOptions = this.logicItem.compareItemOptions;
    const itemExist = value.every((id: string) => {
      return ifItemOptions.some((op: any) => {
        return op.id == id;
      });
    });
    if (!itemExist) {
      callback(new Error("该选项已失效"));
    } else {
      callback();
    }
  }

  // $ handleModules
}
